import { orange } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';
import { bcmeaStyles } from './bcmeaStyles';
import { MuiOverrides } from './overrides';
import palette from './palette';

/**
 * Custom MUI theme for SMB. For more information see links below
 * * [MUI Theme Documentation](https://mui.com/material-ui/customization/theming/)
 * * [MUI Default Theme](https://mui.com/material-ui/customization/default-theme/)
 * * [Theming Components](https://mui.com/material-ui/customization/theme-components/)
 */
export const theme = createTheme({
  typography: {
    /** 
     * Use ProximaNovaRegular as the default font and Roboto as a backup 
     * TODO: Fix this because it isn't working. Is there a better way to load fonts?
     * */
    fontFamily: [bcmeaStyles.fontFamily.proximaNovaRegular, 'Roboto'].join(','),
  },
  status: {
    danger: orange[500],
  },
  palette,
  components: MuiOverrides,
});

export type ITheme = typeof theme;
